export default __webpack_public_path__ + "img/57bed942d584fe953da3ce6c6d257446.svg";